import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { LocalizationOptionsService } from '../../localization-option.service';
import { StackingPlanContainer } from '../stacking-plan.model';
import { FloorClass } from '../../models/floor.class';
import { ElevatorBanksRepository } from './elevator-banks/elevator-banks-repository.service';
import { FloorClassAdapter } from './floor-container-adapter.service';

@Injectable()
export class FloorContainerRepository {
  #floorData = new BehaviorSubject<FloorClass[]>([]);
  floorData$: Observable<FloorClass[]> = this.#floorData.asObservable();

  constructor(
    private floorAdapter: FloorClassAdapter,
    private localizationOptions: LocalizationOptionsService,
    private elevatorBanksRepository: ElevatorBanksRepository
  ) {}

  set(containerData: StackingPlanContainer) {
    const nextFloors = this.floorAdapter.adapt(containerData, this.localizationOptions.getInstance());
    this.elevatorBanksRepository.set(containerData.elevatorBank, nextFloors);
    this.#floorData.next(nextFloors);
  }

  get floorData() {
    return this.#floorData.getValue();
  }

  reset() {
    this.#floorData.next([]);
    this.elevatorBanksRepository.reset();
  }
}
